<template>
    <header class="pt3 mb3 align--center">
        <div class="container">
            <h1 class="m0" title="Chefy"><img class="logo mb1 pl1 pr1" src="../assets/logo.svg" alt="Chefy"></h1>
            <p class="h2">{{headline}}</p>
        </div>
    </header>
</template>

<script>
export default {
    name: 'app_header',
    data() {
        return {
            headline: 'Make meaningful products'
        }
    },
    
}
</script>

<style lang="scss">
  @import '../scss/main.scss'
</style>


// WEBPACK FOOTER //
// src/components/Header.vue